import { Request } from 'express';

export enum HEADERS {
  accept = 'Accept',
  acceptLanguage = 'Accept-Language',
  authorization = 'Authorization',
  contentLength = 'Content-Length',
  contentSecurityPolicy = 'Content-Security-Policy',
  contentSecurityPolicyReportOnly = 'Content-Security-Policy-Report-Only',
  contentType = 'Content-Type',
  origin = 'Origin',
  reportTo = 'Report-To',
  strictTransportSecurity = 'Strict-Transport-Security',
  xAmznTraceId = 'X-Amzn-Trace-Id',
  xContentTypeOptions = 'X-Content-Type-Options',
  xForwardedFor = 'X-Forwarded-For',
  xForwardedHost = 'x-forwarded-host',
  xOriginalUri = 'x-original-uri',
  xPoweredBy = 'X-Powered-By',
  xRealIp = 'x-real-ip',
  xRequestedWith = 'X-Requested-With',
  xRequestId = 'X-Request-Id',
  xRequestTraceId = 'X-Request-Trace-Id',
  xRetryRequest = 'X-Retry-Request',
  xRobotsTag = 'X-Robots-Tag',
  xSessionTraceId = 'X-Session-Trace-Id',
  xTokenChange = 'X-Token-Change',
}

// in seconds
export enum HEADERS_MAX_AGE {
  oneDay = 24 * 60 * 60,
  oneYear = 365 * 24 * 60 * 60,
}

//https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Content-Security-Policy/default-src
export enum CONTENT_POLICY_DIRECTIVES {
  child = 'child-src',
  connect = 'connect-src',
  default = 'default-src',
  font = 'font-src',
  frame = 'frame-src',
  frameAncestors = 'frame-ancestors',
  img = 'img-src',
  manifest = 'manifest-src',
  media = 'media-src',
  object = 'object-src',
  prefetch = 'prefetch-src',
  reportTo = 'report-to',
  reportUri = 'report-uri',
  script = 'script-src',
  scriptAttribute = 'script-src-attr',
  scriptElement = 'script-src-elem',
  style = 'style-src',
  styleAttribute = 'style-src-attr',
  styleElement = 'style-src-elem',
  worker = 'worker-src',
}

export enum CONTENT_POLICY_KEYWORDS {
  blob = 'blob:',
  data = 'data:',
  inline = '\'inline\'',
  none = '\'none\'',
  self = '\'self\'',
  unsafeEval = '\'unsafe-eval\'',
  unsafeInline = '\'unsafe-inline\'',
}

export const getTrackingHeaders = (request: Request): Record<string, string> => ({
  [HEADERS.xForwardedFor]: request.clientIp || '',
  [HEADERS.xRequestTraceId]: request.id,
  [HEADERS.xSessionTraceId]: request.session?.id || null,
});

export const toHeaderValues = (
  options: Record<string, string | string[]>,
): string => Object.entries(options).reduce(
  (result: string[], [key, values]) => {
    switch (true) {
      case typeof values === 'string':
        result.push(`${key} ${values}`);
        break;
      case Array.isArray(values):
        result.push(`${key} ${(values as string[]).join(' ')}`);
        break;
    }

    return result;
  },
  [],
).join('; ');
